import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { ContentCoverImage } from "scmp-app/components/content/content-cover-image";
import { ContentItemHomeSecondaryV2 } from "scmp-app/components/content/content-item-render/variants/home-secondary-v2";
import {
  ActionBar as SecondaryActionBar,
  CoverImage as SecondaryCoverImage,
  Headline as SecondaryHeadline,
} from "scmp-app/components/content/content-item-render/variants/home-secondary-v2/styles";
import { HomeV2SectionTopLead } from "scmp-app/components/home-v2/section-top/lead";

export const LeadCoverImage = styled(ContentCoverImage)``;

export const LeadText = styled.div`
  order: 1;

  ${theme.breakpoints.up("tablet")} {
    order: 2;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    gap: 16px;
  }
`;

export const StyledLead = styled(HomeV2SectionTopLead)`
  ${theme.breakpoints.up("tablet")} {
    gap: 16px;

    ${LeadText} {
      max-inline-size: 594px;
    }
  }
`;

export const FullDivider = styled.div`
  block-size: 1px;

  background-color: #dfdfdf;
`;

export const MidRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 20px;
  }
`;

export const MidItemWrapper = styled.div`
  ${theme.breakpoints.up("tablet")} {
    flex: 1 1 0;

    min-inline-size: 0;
  }
`;

export const BottomRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 20px;
  }
`;

export const BottomItem = styled.div`
  ${theme.breakpoints.up("tablet")} {
    flex: 1 1 0;

    min-inline-size: 0;
  }
`;

export const ItemDivider = styled.div`
  block-size: 1px;

  background-color: #dfdfdf;

  ${theme.breakpoints.up("tablet")} {
    flex: none;
    align-self: stretch;

    inline-size: 1px;
    block-size: auto;
  }
`;

export const StyledMidItem = styled(ContentItemHomeSecondaryV2)`
  ${theme.breakpoints.up("tablet")} {
    grid-template-columns: minmax(0, 1fr) 144px;
  }

  ${SecondaryHeadline} {
    font-size: 15px;
    line-height: 140%;

    ${theme.breakpoints.up("tablet")} {
      font-size: 14px;
    }
  }

  ${SecondaryActionBar} time {
    color: #727272;
    font-size: 11px;
  }

  ${SecondaryCoverImage} {
    ${theme.breakpoints.only("mobile")} {
      display: none;
    }

    ${theme.breakpoints.up("tablet")} {
      inline-size: 144px;
      block-size: 96px;
    }
  }
`;

export const StyledSmallItem = styled(ContentItemHomeSecondaryV2)`
  ${SecondaryHeadline} {
    font-size: 15px;
    line-height: 140%;

    ${theme.breakpoints.up("tablet")} {
      font-size: 14px;
    }
  }

  ${SecondaryActionBar} time {
    color: #727272;
    font-size: 11px;
  }
`;
